// @ts-nocheck
import * as React from 'react';
import { Container, Row, Col } from 'crehana-ui/GridV2';

import { MainFooter } from '@crehana/web';

import PromoCountdownBar from 'Shared/PromoCountdownBar';

import MainMenu from 'Jsx/CrehanaWeb/MainMenuWrapper';

import { InitialStateResult } from 'Utils/getBaseInitialState';

import Header from './sections/Header';
import ProductSection from './sections/ProductSection';
import Legals from './components/Legals';
import { Product } from './types';
import { CUSTOM_MEMBERSHIP_LANDING_PAGE_NAME } from './constants';

export type ExtraState = {};

export type AppProps = {
  products: Product[];
  headerSection: {
    title: string;
    subtitle: string;
    logoUrl: string;
    externalLink?: {
      label: string;
      url: string;
    };
  };
  legalsCopy: string;
  promoBar: {
    message: string;
    shortMessage: string;
    expirationDate: Date;
  };
};

const App: React.FC<InitialStateResult<AppProps & ExtraState>> = ({
  categories,
  countryPrefix,
  products,
  headerSection,
  legalsCopy,
  promoBar,
}) => {
  return (
    <div className="bg-base-dark">
      {promoBar && (
        <PromoCountdownBar
          message={promoBar.message}
          alternativeShortMessage={promoBar.shortMessage}
          expirationDate={promoBar.expirationDate}
        />
      )}
      <MainMenu
        theme="dark"
        logoType="premium"
        layoutConfig={{
          hideTopBanner: true,
          hidePremiumLandingLink: true,
        }}
        amplitudePageName={CUSTOM_MEMBERSHIP_LANDING_PAGE_NAME}
      />
      <Container className="mb-48">
        <Row>
          <Col xs={12} sm={10} offset={{ sm: 1 }}>
            <Header {...headerSection} />
          </Col>
        </Row>
        <ProductSection products={products} />
        {legalsCopy && <Legals legalsCopy={legalsCopy} />}
      </Container>
      <MainFooter isDark />
    </div>
  );
};

export default App;
